import _StudentPaperBasedHomework from './model';
import create from './create';

export const StudentPaperBasedHomework = _StudentPaperBasedHomework;

StudentPaperBasedHomework.create = create;

export default StudentPaperBasedHomework;



// WEBPACK FOOTER //
// ./data/PaperBasedHomework/StudentPaperBasedHomework/index.js